import { ADDRESS_ENV, EXPECTED_CHAIN_ID, envAddress, envString, type HexAddress } from "./config";

export function getDisplayNftAddress(): HexAddress | null {
  return envAddress(ADDRESS_ENV.nft);
}

export function getDisplayCapeTokenAddress(): HexAddress | null {
  return envAddress(ADDRESS_ENV.capeToken);
}

export function shortAddress(address: string): string {
  return `${address.slice(0, 6)}...${address.slice(-4)}`;
}

export function getExplorerAddressUrl(address: string): string {
  const explorer = EXPECTED_CHAIN_ID === 8453
    ? "https://basescan.org"
    : EXPECTED_CHAIN_ID === 84532
      ? "https://sepolia.basescan.org"
      : EXPECTED_CHAIN_ID === 11155111
      ? "https://sepolia.etherscan.io"
      : "https://etherscan.io";
  return `${explorer}/address/${address}`;
}

export function getCodeApeXUrl(): string {
  return envString("VITE_CODE_APE_X_URL") ?? "https://x.com/codeape";
}

export function getUniswapTradeUrl(): string {
  const configured = envString("VITE_UNISWAP_TRADE_URL");
  if (configured) return configured;
  const cape = getDisplayCapeTokenAddress();
  const chain = EXPECTED_CHAIN_ID === 8453 ? "base" : EXPECTED_CHAIN_ID === 84532 ? "base_sepolia" : EXPECTED_CHAIN_ID === 11155111 ? "sepolia" : "mainnet";
  return cape ? `https://app.uniswap.org/swap?chain=${chain}&outputCurrency=${cape}` : `https://app.uniswap.org/swap?chain=${chain}`;
}
